import React, {useState} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';

export const SimpleTabs: React.FC<{
  dataTestId?: string;
  children: React.ReactElement<{label?: string}>[];
  className?: string;
}> = ({dataTestId = 'tabs', children, className}) => {
  const [selectedTabId, setSelectedTabId] = useState(0);
  if (!children) {
    return null;
  }

  return (
    <>
      <Wrapper className={className} data-testid={dataTestId}>
        {children.map((child, index) => {
          return (
            <Selector
              flex={1 / (children.length ?? 1)}
              key={index}
              onClick={() => setSelectedTabId(index)}
              active={selectedTabId === index}
            >
              {child.props.label}
            </Selector>
          );
        })}
      </Wrapper>
      <div>{children[selectedTabId]}</div>
    </>
  );
};

const Wrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  font-size: ${FONT_SIZES.px14};
  font-weight: ${FONT_WEIGHTS.bold};
  height: 50px;
  width: 100%;
`;

const Selector = styled.button<{active?: boolean; flex: number}>`
  align-items: center;
  background-color: transparent;
  border: none;
  border-bottom-style: solid;
  border-bottom-width: 2px;
  border-bottom-color: ${({active}) => (active ? COLORS.Black : 'transparent')};
  cursor: pointer;
  display: flex;
  flex: ${({flex}) => flex};
  font-size: inherit;
  font-weight: inherit;
  justify-content: center;
  text-align: center;
  // eslint-disable-next-line local-rules/css-layout-animation
  transition: border 0.15s;

  &:focus {
    outline: none;
  }
`;
